import * as Moment from 'moment';
import { ApiConfigureDateTime, ApiGetSettings } from "../../../misc/api/DeviceLinkApi/StatStripXpress2";
import { FailedToConfigureDateTimeMessage, FailedToRetrieveSettingsMessage, FailedConfigureDeviceMessage } from "../../../misc/api/DeviceLinkApi/StatStripXpress2Messages";
import { isModelWithError, SessionScheduleItem, ModelWithError, Visit, Query, DeviceTypes } from '../../../misc/api/apiTypes';
import { CannotCreateWrapperErrorMessage } from '../../../misc/api/DeviceLinkApi/GenericMessages';
import { Device } from '../../../misc/api/DeviceLinkApi/Devices';
import { StudyScheduleSession, WebPortalClient } from 'webportalclient';
import { useWebPortalApiClient, WebPortalLegacyClientInternal } from '../../../misc/api/WebPortalTokenClient';

const createVisitWrapperIfNotExists = async (legacyClient: WebPortalLegacyClientInternal, visitScheduleId: string, subjectId: string): Promise<Visit | ModelWithError> => {
    const visits: Query<Visit> = await legacyClient.getVisits({
        Filters: [{
            Member: 'SubjectId',
            Values: [subjectId],
        },
        {
            Member: 'VisitScheduleItemId',
            Values: [visitScheduleId],
        }]
    });

    if (visits.Data.length < 1) {
        return legacyClient.createVisit(subjectId, visitScheduleId);
    }

    return visits.Data[0];
}

export const ConfigureStatStripXpress2 = async (legacyClient: WebPortalLegacyClientInternal, client: WebPortalClient, userEmail: string, subjectId: string, selectedDevice: Device, sessionScheduleItem: StudyScheduleSession, onError: (message: string) => void, onComplete: () => void) => {
    try {
        const dateTimeResult = await ApiConfigureDateTime(selectedDevice.id, Moment().local().format());

        if (!dateTimeResult.isSuccess) {
            onError(FailedToConfigureDateTimeMessage);
            return;
        }

        const settingsResult = await ApiGetSettings(selectedDevice.id);

        if (settingsResult === null) {
            onError(FailedToRetrieveSettingsMessage);
            return;
        }

        const visitWrapperResult = await createVisitWrapperIfNotExists(legacyClient, sessionScheduleItem.studyScheduleVisitId, subjectId);

        if (isModelWithError(visitWrapperResult)) {
            return onError(CannotCreateWrapperErrorMessage);
        }

        const sessionResult = await client.postBloodGlucoseSession({
            visitId: visitWrapperResult.Id,
            name: sessionScheduleItem.label,
            occurred: Moment().toISOString(),
            configurationOccurred: Moment().toISOString(),
            configurationTechnician: userEmail,
            serialNumber: settingsResult.monitorId,
            softwareVersion: settingsResult.softwareVersion,
            status: "BGSS_AWAITING_DATA",
            deviceType: DeviceTypes.StatStripXpress2
        });

        if (sessionResult == null) {
            return onError(CannotCreateWrapperErrorMessage);
        }
        
        await client.patchBloodGlucoseSession({
            configured: true,
        }, sessionResult.id);

        return onComplete();
    }
    catch (err) {
        onError(FailedConfigureDeviceMessage);
    }
}

